import clsx from 'clsx';
import { PrismaEnums } from '@airreading/common';
import { Badge } from '@/components/ui/badge';
import {
  AttendancePolicyV2ActionLevelColorMap,
  AttendancePolicyV2ActionLevelLabelMap,
} from '@/lib/attendance-policy-v2-display';

interface AttendancePolicyV2StatusBadgeProps {
  actionLevel: PrismaEnums.TeacherAttendancePolicyActionLevel;
  'data-testid'?: string;
}

export const AttendancePolicyV2StatusBadge = ({
  actionLevel,
  'data-testid': dataTestId,
}: AttendancePolicyV2StatusBadgeProps) => {
  return (
    <Badge
      data-testid={dataTestId}
      className={clsx(
        'p-1 rounded-[6px] text-[14px] text-center font-bold mx-auto',
        AttendancePolicyV2ActionLevelColorMap[actionLevel],
      )}
    >
      {AttendancePolicyV2ActionLevelLabelMap[actionLevel]}
    </Badge>
  );
};
